<template>
  <div class="company-selector__container align-center">
    <div>
      <AvatarContainer
        class="mb-1 mr-4 ml-2 hover"
        :name="userProfileStore.trustGroup.company.companyName"
        theme="theme1"
        size="large"
      />
    </div>
    <div>
      <p class="company-selector__text">
        {{ userProfileStore.trustGroup.company.companyName }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserProfileStore } from "@/stores/userProfileStore";
import AvatarContainer from "@/components/custom/AvatarContainer.vue";

const userProfileStore = useUserProfileStore();
</script>

<style lang="scss" scoped>
.hover {
  &:hover {
    cursor: default;
  }
}

.company-selector {
  .v-field {
    font-size: 1.2rem !important;
    font-weight: 700;
  }
}

.company-selector__container {
  display: flex; // to work with media queries
}

.company-selector__text {
  font-weight: 700;
  word-break: break-word;
}
</style>
